import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=5d30ac7e&scoped=true"
import script from "./ProductLinks.vue?vue&type=script&lang=js"
export * from "./ProductLinks.vue?vue&type=script&lang=js"
import style0 from "./ProductLinks.vue?vue&type=style&index=0&id=5d30ac7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30ac7e",
  null
  
)

export default component.exports